import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_REFERENCE_ORDERS_LIST } from '../queries/GetOrdersList';

const fetchReferenceOrdersData = async ({ queryKey }) => {
	const [
		,
		{ currentLine, filterValues, modifiedFilter, sort, page, token, setToast },
	] = queryKey;

	if (!token) throw new Error('Token not available');

	try {
		const response = await axios.post(
			`/findReferenceOrders?&prodFamilyId=${encodeURIComponent(currentLine)}`,
			{
				sort: sort?.[0]?.dir || 'des',
				skip: page.skip,
				take: page.take,
				filter: JSON.stringify(modifiedFilter, null, 2),
				column: sort?.[0]?.field || 'promiseDate',
				modelTypes: filterValues,
			},
			{
				headers: {
					Authorization: token,
				},
			}
		);

		const modifiedItems = response.data.items.map((item, index) => {
			const combinedData = {};
			item.codeSplitHeaders.forEach((header, index) => {
				combinedData[header] = item.codeSplit[index];
			});
			return {
				...item,
				...combinedData,
				rowIndex: index + 1 + page.skip,
			};
		});

		return { items: modifiedItems, totalRows: response.data.totalRows };

	} catch (error) {
		if (error.response) {
			setToast({
				showToast: true,
				message: error.response.data,
				type: 'error',
			});
		} else {
			setToast({ showToast: true, message: error.message, type: 'error' });
		}
	}
};

export const useReferenceOrdersData = (params) => {
	return useQuery({
		queryKey: [
			GET_REFERENCE_ORDERS_LIST,
			{ ...params, filter: params.debouncedFilter },
		],
		queryFn: fetchReferenceOrdersData,
		enabled: !!params.token && !!params.filterValues,
		retry: false,
	});
};
